import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV, CONTACT, SERVICES, LANGUAGES } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-navy text-white overflow-hidden grain">
    <div className="relative z-[2] mx-auto max-w-7xl px-5 md:px-8 py-20 md:py-28">
      <div className="border-b border-white/15 pb-14 mb-14">
        <p className="label-eyebrow">Let's Talk</p>
        <div className="mt-5 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <h2 className="font-serif text-4xl md:text-6xl leading-none max-w-2xl">
            Ready for comfort you can count on?
          </h2>
          <Link
            to="/contact"
            data-testid="footer-quote-btn"
            className="inline-flex items-center rounded-full bg-gold px-8 py-4 text-sm font-semibold text-navy transition-transform duration-300 hover:scale-105 whitespace-nowrap"
          >
            Request a Quote
          </Link>
        </div>
      </div>

      <div className="grid gap-12 md:grid-cols-4">
        <div>
          <img src="/logo-white.png" alt="Lighthouse Home Services" className="h-20 w-auto" />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
            Family-owned residential HVAC, proudly guiding Massachusetts homeowners toward better comfort.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Quick Links</p>
          <ul className="space-y-3 text-sm text-white/70">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-white transition-colors duration-200">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Services</p>
          <ul className="space-y-3 text-sm text-white/70">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="hover:text-white transition-colors duration-200">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Get in Touch</p>
          <ul className="space-y-4 text-sm text-white/70">
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-3 hover:text-white transition-colors"><Phone className="h-4 w-4 text-gold" /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail className="h-4 w-4 text-gold" /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-gold" /> {CONTACT.address}</li>
            <li className="text-white/50">{CONTACT.area}</li>
          </ul>
          <div className="mt-7">
            <p className="text-xs uppercase tracking-[0.2em] text-gold mb-3">Languages We Speak</p>
            <ul className="flex flex-wrap gap-2" data-testid="footer-languages">
              {LANGUAGES.map((l) => (
                <li key={l} className="rounded-full border border-white/20 px-3 py-1 text-xs text-white/70">{l}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Lighthouse Home Services. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
          <span>Mass Save® HPIN Contractor</span>
        </div>
      </div>
    </div>
  </footer>
);
